import React, { useEffect } from "react";

// =====================================================================
// PEGA AQUÍ EL TEXTO DEL AVISO DE PRIVACIDAD, entre las dos comillas invertidas ( ` ).
//
// Reglas para que se vea bien:
// 1. Deja UNA línea vacía entre cada párrafo.
// 2. Los títulos de sección empiezan con número y punto: "1. Responsable".
// 3. Los subtítulos van solos en su línea, sin punto final.
// 4. Cada viñeta va en su propia línea, empezando con "•" o con "a)", "b)", etc.
// =====================================================================
const TEXTO = `
AVISO DE PRIVACIDAD

Última actualización: 15 octubre 2026 

I.	IDENTIDAD DEL RESPONSABLE 

SALUD VIRTUAL PLATAFORMA DIGITAL SAS DE CV (en lo sucesivo, “Salvir”), es el responsable del tratamiento y protección de los datos personales que nos proporcione, en cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y demás disposiciones legales aplicables. Para cualquier duda o aclaración relacionada con este aviso, puede contactarnos a través del correo electrónico [contacto@salvir.com] o al teléfono [+52 56 4481 1995].  

II.	DATOS PERSONALES RECABADOS 

Para la correcta prestación de nuestros servicios, Salvir recaba y trata los siguientes datos personales: 
•	Datos Generales: 
o	Nombre, apellidos, sexo, fecha de nacimiento, correo electrónico, teléfono móvil y fijo. 
•	Datos Académicos y Profesionales: 
o	Especialidad médica, nombre de la clínica o consultorio, institución(es) de formación, títulos y certificados académicos, cédula profesional, cédula de especialidad, cédula de subespecialidad y/o cedula de alta especialidad, historial profesional y afiliaciones a instituciones médicas. 
•	Datos de Ubicación: 
o	Dirección completa del consultorio (calle, número, colonia, ciudad, estado y código postal). 
•	Datos de Acceso y Seguridad: 
o	Nombre de usuario, contraseña (almacenada mediante técnicas de cifrado seguro), y, en casos necesarios, copia de identificación oficial para validación de identidad. 
•	Datos Administrativos y de Facturación: 
o	Información financiera, datos bancarios, RFC, métodos de pago y cualquier otro dato requerido para procesos de facturación y/o suscripción. o Firma electrónica avanzada y sello digital (cuando sean requeridos para la emisión de facturas electrónicas y procesos administrativos). 
•	Datos Personales Sensibles: 
o	Información considerada sensible, en particular los datos bancarios del doctor necesarios para la realización de pagos y suscripciones. Dichos datos serán tratados únicamente a través de la plataforma externa Stripe, la cual cuenta con medidas de seguridad avanzadas que garantizan su protección, previa autorización expresa y por escrito del titular. 
o	Salvir, como proveedor de servicios tecnológicos para profesionales de la salud, puede almacenar y procesar información clínica de pacientes registrada por sus usuarios, incluyendo antecedentes médicos, diagnósticos, tratamientos, medicamentos, resultados de estudios, notas clínicas y otros datos relacionados con su estado de salud.
o	El profesional de la salud que registra la información es responsable de contar con las bases legales y los consentimientos correspondientes para su tratamiento. Salvir tratará dicha información para prestar los servicios tecnológicos contratados, conforme a las instrucciones aplicables del profesional de la salud y a las medidas de seguridad implementadas en la Plataforma. 

III.	FINALIDADES DEL TRATAMIENTO DE LOS DATOS 

Los datos personales recabados serán utilizados para las siguientes finalidades: 
A.	Finalidades Primarias 
1.	Registro y Creación de Cuenta: 
o	Permitir el acceso y uso de la plataforma Salvir mediante la creación y administración de una cuenta personal. 
2.	Identificación y Autenticación: 
o	Verificar la identidad del usuario para garantizar el acceso seguro y personalizado a nuestros servicios. 
3.	Gestión y Administración de la Plataforma: 
o	Administrar, operar y mantener la plataforma, incluyendo la actualización de perfiles y optimización de servicios. 
4.	Procesamiento de Pagos y Facturación: 
o	Realizar procesos de facturación y pagos de suscripciones a través de terceros, utilizando Stripe para el tratamiento seguro de datos bancarios. 
5.	Cumplimiento de Obligaciones Legales: 
o	Atender requerimientos legales y normativos vigentes, y responder ante autoridades competentes en caso de requerimientos legales. 
6.	Prestación de Servicios de Gestión Clínica:
o	Salvir permite el registro, almacenamiento, organización, consulta y procesamiento de información clínica y administrativa proporcionada por los profesionales de la salud, mediante las funcionalidades disponibles en la Plataforma.
o	El profesional de la salud es responsable de la información que registra, de su exactitud, integridad y actualización, así como de obtener los consentimientos correspondientes y cumplir con las obligaciones legales y profesionales aplicables a su actividad.
o	Salvir actúa como proveedor de herramientas tecnológicas y no interviene en las decisiones clínicas, diagnósticos, tratamientos ni en la relación profesional entre el usuario y sus pacientes.
B.	Finalidades Secundarias 
1.	Mejora y Optimización del Servicio: 
o	Realizar análisis de uso, estudios estadísticos y evaluaciones para mejorar la experiencia del usuario y el rendimiento de la plataforma. o Realización de encuestas de satisfacción y análisis de tendencias de uso para mejorar la experiencia del usuario. 
2. Desarrollo de Nuevas Funcionalidades: 
o	Implementar mejoras, nuevas características y servicios adicionales en base a las tendencias y necesidades detectadas. o Investigación y desarrollo tecnológico para optimizar servicios médicos digitales y procesos de automatización en la plataforma. 
3. Publicidad y Promociones: 
o	Enviar información sobre novedades, actualizaciones, promociones y publicidad relacionada con nuestros servicios. 
4. Uso de Cookies y Tecnologías de Seguimiento: 
o	Utilizar cookies y otras tecnologías similares para personalizar el contenido, analizar el tráfico del sitio y ofrecer una experiencia de navegación óptima. Los usuarios podrán configurar su navegador para rechazar estas tecnologías, aunque ello podría limitar algunas funcionalidades de la plataforma. 
 
IV.	DATOS BANCARIOS PARA FINES DE PAGO 

En caso de que se recabe información bancaria del titular (como número de cuenta o CLABE interbancaria) para realizar pagos relacionados con el uso de la plataforma, dichos datos serán tratados exclusivamente para los fines correspondientes y bajo medidas de seguridad apropiadas. 
Salvir no almacena ni procesa directamente información financiera confidencial como tarjetas de crédito; dicha información es gestionada por la plataforma Stripe, proveedor externo que opera bajo altos estándares de seguridad y cumplimiento normativo.  

V.	TRANSFERENCIA DE DATOS PERSONALES 

Salvir podrá compartir datos personales con proveedores tecnológicos que intervengan en la prestación de sus servicios, tales como proveedores de infraestructura, alojamiento, almacenamiento, seguridad, comunicaciones y procesamiento de pagos, exclusivamente en la medida necesaria para cumplir las finalidades descritas en este Aviso de Privacidad.
Cuando dichos proveedores traten información por cuenta de Salvir y siguiendo sus instrucciones, actuarán como encargados del tratamiento, conforme a las disposiciones legales y contractuales aplicables. Las transferencias de datos personales a terceros que actúen como responsables independientes se realizarán únicamente cuando exista una base legal que las permita y, cuando corresponda, con el consentimiento del titular. 
•	Proveedores de Servicios Tecnológicos: 
o 	Empresas encargadas del hosting, almacenamiento, y seguridad de la información. 
•	Procesadores de Pagos: 
o 	Plataformas especializadas para el procesamiento seguro de pagos y datos bancarios. 
•	Despachos Contables y Fiscales: 
o Firmas externas encargadas de la facturación y cumplimiento de obligaciones fiscales cuando el usuario requiera la emisión de comprobantes fiscales. 
•	Autoridades Competentes: 
o 	Entidades gubernamentales o judiciales en cumplimiento de obligaciones legales. 
•	Otros Terceros: 
o Cualquier otro colaborador que, para el adecuado cumplimiento de las finalidades de este aviso, reciba datos personales, siempre bajo contratos que garanticen la protección de dichos datos. 
Todos los terceros receptores están obligados a tratar la información conforme a los lineamientos establecidos en la LFPDPPP y demás normativas aplicables.  

VI.	CONSERVACIÓN DE LOS DATOS PERSONALES 

De conformidad con la normativa mexicana, Salvir conservará sus datos personales durante el tiempo estrictamente necesario para cumplir con las finalidades para las cuales fueron recabados.  
La información clínica de pacientes registrada por los profesionales de la salud estará sujeta a los plazos de conservación que resulten aplicables conforme a la legislación mexicana.
Los plazos de conservación establecidos para los datos de cuenta y administrativos de los profesionales de la salud no implican la eliminación automática de los expedientes clínicos al concluir la relación comercial.
La conservación, disponibilidad, exportación y, cuando legalmente corresponda, eliminación de dicha información se sujetarán a las obligaciones aplicables y a las condiciones del servicio contratado.
Plazos de Conservación: 
•	Los datos se conservarán hasta la finalización de la relación comercial. 
•	Conservaremos los datos del profesional de la salud durante un plazo de hasta 5 años después de la cancelación de la cuenta, únicamente para fines legales, fiscales 
o contractuales. Posteriormente, serán eliminados o anonimizados de forma segura conforme a la LFPDPPP, salvo que la legislación aplicable establezca un plazo mayor o se requiera su conservación por motivos legales, contables o de auditoría. 
•	En caso de requerimientos legales, fiscales, contables o de auditoría, algunos datos podrán ser retenidos por un período adicional hasta cumplir con las obligaciones normativas. 
•	Una vez cumplido el plazo, se procederá a la eliminación segura de la información, sin perjuicio de las obligaciones legales que obliguen a conservar ciertos datos por períodos adicionales.  

VII.	EJERCICIO DE DERECHOS  

Los titulares de datos personales tienen derecho a ejercer los siguientes derechos, conocidos como derechos ARCO (Acceso, Rectificación, Cancelación y Oposición): 
1.	Acceso: Conocer qué datos personales poseemos y la finalidad de su tratamiento. 
2.	Rectificación: Corregir o actualizar aquellos datos que resulten inexactos o incompletos. 
3.	Cancelación:  Solicitar la eliminación de sus datos personales cuando considere que no se requieren para los fines establecidos. 
4. Oposición: Oponerse al tratamiento de sus datos personales para fines específicos. 
Procedimiento para ejercer los derechos: 
•	Envíe un correo electrónico a [contacto@salvir.com] en el que incluya: 
•	Su nombre completo y datos de contacto. 
•	Una descripción detallada del derecho que desea ejercer. 
•	Copia de una identificación oficial vigente para efectos de verificación. 
•	SALVIR se compromete a responder su solicitud en un plazo máximo de 20 días hábiles, previo proceso de verificación de identidad conforme a lo establecido por la ley. 
•	Si la solicitud es incompleta o requiere información adicional, se notificará al usuario dentro de los primeros 20 días hábiles posteriores a la recepción. 
•	El usuario tendrá 3 días hábiles para completar la información requerida. Si no lo hace dentro de este plazo, la solicitud se tendrá por no presentada.  

VIII.	REVOCACIÓN DEL CONSENTIMIENTO 

Si en algún momento decide revocar el consentimiento otorgado para el tratamiento de sus datos personales, podrá hacerlo comunicándose a través del correo electrónico [contacto@salvir.com]. La revocación se hará efectiva en el menor tiempo posible, sin que ello afecte la legalidad del tratamiento efectuado con anterioridad a la revocación.  
IX.	USO DE COOKIES Y OTRAS TECNOLOGÍAS DE SEGUIMIENTO 
Para optimizar la experiencia del usuario y mejorar nuestros servicios, Salvir utiliza cookies y tecnologías de seguimiento similares. Estas herramientas permiten: 
•	Personalizar el contenido y los anuncios de acuerdo con sus intereses. 
•	Analizar el tráfico y el uso de la plataforma para la toma de decisiones. 
•	Facilitar la navegación y mejorar la funcionalidad del sitio. 
Usted puede gestionar el uso de cookies a través de la configuración de su navegador. Sin embargo, rechazar su uso podría limitar el acceso a ciertas funcionalidades de la plataforma.  

X.	MEDIDAS DE SEGURIDAD 

Salvir implementa medidas de seguridad técnicas, administrativas y físicas orientadas a proteger sus datos personales contra accesos no autorizados, pérdida, alteración, divulgación o destrucción. Entre estas medidas se destacan: 
•	Cifrado de la Información: 
	o 	Uso de técnicas de encriptación para contraseñas y datos sensibles. 
•	Control de Acceso: 
o 	Protocolos de autenticación robustos y restricción del acceso a personal autorizado. 
•	Plataformas Seguras: 
o Empleo de servicios de terceros, como Stripe, para el manejo seguro de información bancaria y transacciones. 
•	Auditorías y Revisiones Periódicas: 
o Revisiones y evaluaciones de sus medidas de seguridad conforme a sus procedimientos internos, con el objetivo de identificar riesgos y oportunidades de mejora 

XI.	MODIFICACIONES AL AVISO DE PRIVACIDAD 

Salvir podrá modificar o actualizar el presente Aviso de Privacidad como consecuencia de cambios legales, regulatorios, operativos, tecnológicos o derivados de mejoras en sus servicios.
La versión vigente estará disponible en el sitio web oficial de Salvir, indicando su fecha de última actualización. Las modificaciones se comunicarán a través de los medios que Salvir tenga habilitados para tal efecto, incluyendo, según corresponda, notificaciones dentro de la Plataforma o comunicaciones al correo electrónico registrado.
Cuando un cambio requiera legalmente un nuevo consentimiento, este se solicitará conforme a las disposiciones aplicables. 
XII.	CONTACTO 
Para cualquier duda, aclaración o para ejercer sus derechos ARCO, por favor comuníquese con nuestro Departamento de Protección de Datos Personales a través de: 
•	Correo electrónico: contacto@salvir.com 
•	Teléfono: +52 56 4481 1995  
ACEPTACIÓN DEL AVISO DE PRIVACIDAD 
Al utilizar los servicios de SALVIR, usted reconoce haber leído, comprendido y aceptado las condiciones establecidas en este aviso de privacidad, autorizando el tratamiento de sus datos personales conforme a lo aquí descrito. 
 
`;

const TITULO_SECCION = /^\d+\.\s/;
const VINETA = /^(•|-|[a-z]\))\s*/;

// Convierte el texto pegado en bloques: título, sección, subtítulo o párrafos.
function armarBloques(texto) {
  return texto
    .trim()
    .split(/\n\s*\n/)
    .map((bloque, i) => {
      const lineas = bloque.split("\n").map((l) => l.trim()).filter(Boolean);
      if (lineas.length === 0) return null;

      if (i === 0) return { tipo: "titulo", texto: lineas.join(" ") };

      if (lineas.length === 1) {
        const linea = lineas[0];
        if (TITULO_SECCION.test(linea)) return { tipo: "seccion", texto: linea };
        if (linea.length < 100 && !linea.endsWith(".") && !VINETA.test(linea)) {
          return { tipo: "subtitulo", texto: linea };
        }
      }

      // Párrafo normal: junta líneas cortadas, pero cada viñeta va aparte.
      const items = [];
      lineas.forEach((linea) => {
        if (VINETA.test(linea) || items.length === 0) {
          items.push({ texto: linea, vineta: VINETA.test(linea) });
        } else {
          items[items.length - 1].texto += " " + linea;
        }
      });
      return { tipo: "parrafos", items };
    })
    .filter(Boolean);
}

const estilos = {
  pagina: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "40px 20px 60px",
    color: "#334155",
    lineHeight: 1.7,
    fontSize: 15,
    background: "#ffffff",
  },
  titulo: { fontSize: 28, marginBottom: 8, color: "#333", fontWeight: 650 },
  seccion: { fontSize: 20, marginTop: 36, marginBottom: 10, color: "#17a6ad" },
  subtitulo: { fontSize: 16, marginTop: 22, marginBottom: 6, color: "#101828" },
  parrafo: { margin: "0 0 12px", textAlign: "justify" },
  vineta: { margin: "0 0 8px", paddingLeft: 22, textAlign: "justify" },
};

const AvisoPrivacidadSalvir = () => {
  useEffect(() => {
    document.title = "Aviso de Privacidad | Salvir";
    window.scrollTo(0, 0);
  }, []);

  const bloques = armarBloques(TEXTO);

  return (
    <main style={estilos.pagina}>
      {bloques.map((b, i) => {
        if (b.tipo === "titulo") return <h1 key={i} style={estilos.titulo}>{b.texto}</h1>;
        if (b.tipo === "seccion") return <h2 key={i} style={estilos.seccion}>{b.texto}</h2>;
        if (b.tipo === "subtitulo") return <h3 key={i} style={estilos.subtitulo}>{b.texto}</h3>;
        return (
          <div key={i}>
            {b.items.map((item, j) => (
              <p key={j} style={item.vineta ? estilos.vineta : estilos.parrafo}>
                {item.texto}
              </p>
            ))}
          </div>
        );
      })}
    </main>
  );
};

export default AvisoPrivacidadSalvir;